export const NULL_ORDER_ID = "Third-party";
export const THIRD_PARTY_SOURCE = "third-party";
